const firebaseConfig = {
    apiKey: "AIzaSyD85LsY5gNweqdI4_7S9ka-xkvHoncgV-E",
    authDomain: "newsportal-website.firebaseapp.com",
    projectId: "newsportal-website",
    storageBucket: "newsportal-website.appspot.com",
    messagingSenderId: "707927028310",
    appId: "1:707927028310:web:d9d9240c235b54f9d5c1f7"
  };

  export default firebaseConfig;